
(function() {
  var result = { translations: { "id": { "i18n": { "duration": { "seconds": "{{ seconds }} dtk", "minutes": "{{ minutes }}  mnt", "hours": "{{ hours }} jam", "hoursAndMinutes": "{{ hours }} jam {{ minutes }} mnt", "days": "{{ days }} hari", "shortForm": { "seconds": "{{ seconds }}d", "minutes": "{{ minutes }}m", "hours": "{{ hours }}j", "days": "{{ days }}h", "hoursAndMinutes": "{{ hours }}j {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "id": "static-7.1023"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1023",
    "ar-eg": "static-7.1023",
    "bg": "static-7.1023",
    "bn": "static-7.1023",
    "ca-es": "static-7.1023",
    "cs": "static-7.1023",
    "da": "static-7.1023",
    "de": "static-7.1023",
    "el": "static-7.1023",
    "en-gb": "static-7.1023",
    "en": "static-7.1023",
    "es-mx": "static-7.1023",
    "es": "static-7.1023",
    "et": "static-7.1023",
    "fi": "static-7.1023",
    "fr-ca": "static-7.1023",
    "fr": "static-7.1023",
    "he-il": "static-7.1023",
    "hi": "static-7.1023",
    "hr": "static-7.1023",
    "hu": "static-7.1023",
    "id": "static-7.1023",
    "it": "static-7.1023",
    "ja": "static-7.1023",
    "ko": "static-7.1023",
    "lt": "static-7.1023",
    "ms": "static-7.1023",
    "nl": "static-7.1023",
    "no": "static-7.1023",
    "pl": "static-7.1023",
    "pt-br": "static-7.1023",
    "pt-pt": "static-7.1023",
    "ro": "static-7.1023",
    "ru": "static-7.1023",
    "sk": "static-7.1023",
    "sl": "static-7.1023",
    "sv": "static-7.1023",
    "th": "static-7.1023",
    "tl": "static-7.1023",
    "tr": "static-7.1023",
    "uk": "static-7.1023",
    "vi": "static-7.1023",
    "x-pseudo": "static-7.1023",
    "zh-cn": "static-7.1023",
    "zh-hk": "static-7.1023",
    "zh-tw": "static-7.1023"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:id', {version: 'static-7.1023'}); }
})();


